import React from 'react';
import Typography from '../atoms/Typography';
import Button from '../atoms/Button';
import ChevronRightIcon from '../atoms/ChevronRightIcon';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setIsEdit , setId} from '../../redux/appDetails/reducer';
import { resetComplaintManagementState } from '../../redux/complaintmanagement/reducers';
import { resetStatusState } from '../../redux/status/reducers';

const QUERY_TYPE_STORAGE_KEY = 'aira-query-complaintTypeId';
/**
 * Card footer molecule — "Updated on…" text + Configure button.
 */
export default function CardFooter({
  updatedOn,
  openLabel = 'Open',
  configureLabel = 'Configure',
  onOpen: _onOpen,
  // onConfigure,
  className = '',
  id: _id,
  title: _title,
}) {

  const navigate = useNavigate();

  // const onConfigure = () => {
  //   if (onConfigure) {
  //     onConfigure({ id: _id, title: _title });
  //   }
  // };
  const dispatch = useDispatch();
  const complaintTypeId = _id?.data ?? _id?.id ?? _id?._id ?? _id;

  const onOpenClick = () => {
    const complaintTypeId = _id?.data ?? _id?.id ?? _id?._id ?? _id;
    if (complaintTypeId != null && complaintTypeId !== '') {
      const id = String(complaintTypeId);
      try {
        sessionStorage.setItem(QUERY_TYPE_STORAGE_KEY, id);
      } catch {
        // Ignore storage failures (private mode / disabled storage).
      }
      dispatch(setId(id));
      dispatch(resetComplaintManagementState());
      dispatch(resetStatusState());
      navigate(`/complaintmanagement/${id}`);
      return;
    }
    navigate(`/complaintmanagement`);
}

  return (
    <div className={`ca-system-card__footer ${className}`.trim()}>
      <Typography variant="small" as="span">
        {updatedOn ? `Updated on ${updatedOn}` : ''}
      </Typography>
      <div className="ca-system-card__footer-actions">
        <Button size="sm" onClick={onOpenClick}>
          {openLabel}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={()=>{
            if (complaintTypeId == null || complaintTypeId === '') return;
            const id = String(complaintTypeId);
            dispatch(setIsEdit({ data: true }));
            dispatch(setId(id));
            console.log("Configure button clicked");
            console.log("ID:", id);
            navigate(`/settings/${id}?step=1`);
            // onConfigure?.({ id: _id, title: _title });
          }}
          endIcon={<ChevronRightIcon size={14} color="currentColor" />}
        >
          {configureLabel}
        </Button>
      </div>
    </div>
  );
}
